import React from 'react';

const AboutStats = () => {
    return (
        <section className="about-stats pt-120 pb-120">
            <div className="container">
                {/* Header row to introduce stats/footprint */}
                <div className="row align-items-center mb-60">
                    <div className="col-lg-6">
                        <div className="da-sec-title">
                            <span className="sub_title" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#f12521', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', fontSize: '14px' }}>
                                <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#f12521' }}></span>
                                Our Footprint & Impact
                            </span>
                            <h2 className="title mt-2" style={{ fontSize: '38px', fontWeight: '800', color: '#0e131c', lineHeight: '1.2' }}>
                                Built for scale.<br />Structured for craft.
                            </h2>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <p style={{ fontSize: '18px', color: '#555', lineHeight: '1.7', margin: 0, paddingLeft: '15px', borderLeft: '3px solid #f12521' }}>
                            We operate at the intersection of deep technical expertise and global delivery. By combining a principal commercial presence in Australia with high-fidelity engineering in Nepal, we offer absolute reliability and craftsmanship.
                        </p>
                    </div>
                </div>

                {/* Stats cards row */}
                <div className="row g-4 mb-40">
                    <div className="col-md-4">
                        <div className="stat-box-modern">
                            <span className="stat-icon">🚀</span>
                            <h3>20+</h3>
                            <p>Years experience</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="stat-box-modern">
                            <span className="stat-icon">🌍</span>
                            <h3>3</h3>
                            <p>Continents served</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="stat-box-modern">
                            <span className="stat-icon">🎯</span>
                            <h3>∞</h3>
                            <p>Attention to detail</p>
                        </div>
                    </div>
                </div>

                {/* Locations row */}
                <div className="row g-4">
                    <div className="col-md-6">
                        <div className="location-card-modern">
                            <div className="d-flex align-items-center mb-3">
                                <span className="flag-badge">🇦🇺</span>
                                <div>
                                    <h4>Headquarters</h4>
                                    <span className="loc-sub">Sydney, Australia</span>
                                </div>
                            </div>
                            <p>
                                Our commercial home. Client relationships, contracts, and principal engineering direction are managed here.
                            </p>
                            <div className="bg-watermark">AUS</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="location-card-modern">
                            <div className="d-flex align-items-center mb-3">
                                <span className="flag-badge">🇳🇵</span>
                                <div>
                                    <h4>Development House</h4>
                                    <span className="loc-sub">Kathmandu, Nepal</span>
                                </div>
                            </div>
                            <p>
                                Fully equipped engineering studio in the Kathmandu Valley — where the team builds, day in and day out.
                            </p>
                            <div className="bg-watermark">NPL</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutStats;
